import BaseNavBar from "./BaseNavBar";
import { getCountry } from "./CountryUtil";

function Download(props) {
    return (
        <div className="main-layout contineer_page">
            <header>
                <BaseNavBar {...props} active='download' />
            </header>

            <div className="backgro_mh">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="heding">
                                <h2>Download</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div id="about" className="about">
                <div className="container">
                    <div className="row display_boxflex">
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                            <div className="about-box">
                                {getCountry(props.match.params.siteid).playStoreUrl ? (
                                    <a href={getCountry(props.match.params.siteid).playStoreUrl + "&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"} >
                                        <img alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png' />
                                    </a>) : <img src="/images/playstore-soon.png" className="commingsoonImg"></img>
                                }
                                {getCountry(props.match.params.siteid).appStoreUrl ? (
                                    <a href={getCountry(props.match.params.siteid).appStoreUrl+"?itsct=apps_box_badge&amp;itscg=30200"} className="ios_banner">
                                        <img src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&amp;releaseDate=1619395200&h=b5be9fa3b2650d740478e24348734f58" alt="Download on the App Store" />
                                    </a>) : <img src="/images/appstore-soon.png" className="commingsoonImg"></img>
                                }


                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}

export default Download;
